"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildCollectionToolbar = void 0;
const react_1 = __importDefault(require("react"));
const Toolbar_1 = require("../../Toolbar");
function buildCollectionToolbar({ config, payloadGetter, model, buildIn }) {
    var _a, _b, _c, _d, _e;
    const hasToolbar = !!((_a = config === null || config === void 0 ? void 0 : config.items) === null || _a === void 0 ? void 0 : _a.length);
    if (!hasToolbar) {
        return {
            element: null,
            contextMenuActions: []
        };
    }
    const groups = (_b = config === null || config === void 0 ? void 0 : config.groups) !== null && _b !== void 0 ? _b : [];
    const payload = payloadGetter();
    const contextMenuActions = [];
    function takeContextMenuFormToolbarItem(item) {
        if (item.contextMenu) {
            contextMenuActions.push(item.contextMenu);
        }
    }
    const items = (_d = (_c = config === null || config === void 0 ? void 0 : config.items) === null || _c === void 0 ? void 0 : _c.map((item) => {
        takeContextMenuFormToolbarItem(item);
        if (typeof item === 'function') {
            return item(model);
        }
        return {
            type: Toolbar_1.TOOLBAR_ITEM_TYPE.customControl,
            hasOffset: item.hasOffset,
            hasStretch: item.hasStretch,
            isAction: item.isAction,
            decorators: item.decorators,
            disabled: item.disabled,
            render: (injectProps) => item.render(model, injectProps)
        };
    })) !== null && _d !== void 0 ? _d : [];
    return {
        element: (config === null || config === void 0 ? void 0 : config.decorator) ? (config.decorator({
            disabled: config === null || config === void 0 ? void 0 : config.disabled,
            items: items,
            groups: groups,
            payload: payload,
            buildIn
        })) : (react_1.default.createElement(Toolbar_1.Toolbar, { items: items, buildIn: buildIn, groups: (_e = config === null || config === void 0 ? void 0 : config.groups) !== null && _e !== void 0 ? _e : [], payload: payload, disabled: config === null || config === void 0 ? void 0 : config.disabled })),
        contextMenuActions: contextMenuActions
    };
}
exports.buildCollectionToolbar = buildCollectionToolbar;
//# sourceMappingURL=buildCollectionToolbar.js.map